import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

const getTiposDiff = async (proyectoId, version) => {
  const resp = await axios.get(
    `/api/v1/tipos/${proyectoId}/stats/${version}/diff`
  )
  return resp.data
}

export const useTiposDiff = (proyectoId, version) => {
  const { data, isLoading, error } = useQuery(
    ['tiposDiff', `${proyectoId}-${version}`],
    () => getTiposDiff(proyectoId, version)
  )

  return { data, isLoading, error }
}
